import * as React from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../../api";
import { Oops } from "../../../utilities/oops";
import { DEFAULT_PAGE } from "../../../utilities/constants";
import { LoginProps, LoginViewModel } from "./login.types";
import { logger } from "../../../utilities/logger";
import { LogData } from "@rogoag/shared-ts";
import { EMAIL_PATTERN } from "../common";

export function useLoginViewModel(props: LoginProps): LoginViewModel {
	const [username, setEmail] = React.useState("");
	const [password, setPassword] = React.useState("");
	const [loading, setLoading] = React.useState(false);
	const [emailError, setEmailError] = React.useState("");
	const [passwordError, setPasswordError] = React.useState("");
	const [error, setError] = React.useState("");
	const navigate = useNavigate();

	const handleEmailChange = (event: { target: { value: React.SetStateAction<string> } }) => {
		setEmailError("");
		// validate that username is an email with regex
		if (!EMAIL_PATTERN.test(event.target.value.toString())) {
			setEmailError("Invalid email address");
		}

		setEmail(event.target.value);
	};

	const handlePasswordChange = (event: { target: { value: React.SetStateAction<string> } }) => {
		setPassword(event.target.value);
	};

	const handleSubmit = async (event: { preventDefault: () => void }) => {
		const logData: LogData = {
			function: "login.viewmodel.handleSubmit",
			username: username,
		};
		try {
			setError("");
			if (!username) {
				setEmailError("");
				return;
			}
			if (!password) {
				setPasswordError("");
				return;
			}
			setLoading(true);
			event.preventDefault();
			const user = await API.Users.login(username, password);
			if (user) {
				logger.log("Login successful", logData);
				props.setLoggedIn(user);
				navigate(DEFAULT_PAGE);
			} else {
				logger.warning("Login failed: No user returned", logData);
			}
		} catch (error: any) {
			Oops.handleError(error, logData.function, username);
		} finally {
			setLoading(false);
		}
	};

	const navigateToRegister = () => {
		navigate("/register");
	};

	const navigateToForgotPassword = () => {
		navigate("/forgot-password");
	};

	const isSubmitDisabled = loading || !username || !password || !!emailError || !!passwordError;

	return {
		username,
		password,
		loading,
		emailError,
		passwordError,
		error,
		handleEmailChange,
		handlePasswordChange,
		handleSubmit,
		navigateToRegister,
		navigateToForgotPassword,
		isSubmitDisabled,
	};
}
